// ===========================================
// Products Page
// ===========================================
// Admin page for managing product catalog and categories

import { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import PageHeader from '../../components/common/PageHeader';
import ProductsTab from '../../components/admin/pricing/ProductsTab';
import ProductCategoriesTab from '../../components/admin/pricing/ProductCategoriesTab';

// ===========================================
// MAIN COMPONENT
// ===========================================

export default function ProductsPage() {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Box>
      <PageHeader
        title="Products"
        subtitle="Manage product catalog and inventory"
        breadcrumbs={[
          { label: 'Admin', path: '/admin' },
          { label: 'Products' },
        ]}
      />

      <Tabs
        value={activeTab}
        onChange={(_, v: number) => setActiveTab(v)}
        sx={{ mb: 3, borderBottom: 1, borderColor: 'divider' }}
      >
        <Tab label="Products" />
        <Tab label="Categories" />
      </Tabs>

      {activeTab === 0 && <ProductsTab />}
      {activeTab === 1 && <ProductCategoriesTab />}
    </Box>
  );
}
